var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ios-status-bar",class:!_vm.appIs.auth && _vm.$store.state.device.hasFinishedNativeSplashScreen
      ? 'white'
      : _vm.$store.state.device.statusBarColor})}
var staticRenderFns = []

export { render, staticRenderFns }